import './Input.css';

export default function Input({
  label,
  error,
  hint,
  type = 'text',
  id,
  className = '',
  ...props
}) {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`input-group ${error ? 'input-group--error' : ''} ${className}`}>
      {label && (
        <label htmlFor={inputId} className="input-group__label">
          {label}
        </label>
      )}
      <input
        type={type}
        id={inputId}
        className="input-group__input"
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : hint ? `${inputId}-hint` : undefined}
        {...props}
      />
      {error && (
        <span id={`${inputId}-error`} className="input-group__error" role="alert">
          {error}
        </span>
      )}
      {hint && !error && (
        <span id={`${inputId}-hint`} className="input-group__hint">
          {hint}
        </span>
      )}
    </div>
  );
}

export function Textarea({
  label,
  error,
  hint,
  id,
  rows = 3,
  maxLength,
  value = '',
  className = '',
  ...props
}) {
  const inputId = id || `textarea-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`input-group ${error ? 'input-group--error' : ''} ${className}`}>
      {label && (
        <label htmlFor={inputId} className="input-group__label">
          {label}
        </label>
      )}
      <textarea
        id={inputId}
        className="input-group__input input-group__textarea"
        rows={rows}
        maxLength={maxLength}
        value={value}
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : hint ? `${inputId}-hint` : undefined}
        {...props}
      />
      <div className="input-group__footer">
        {error && (
          <span id={`${inputId}-error`} className="input-group__error" role="alert">
            {error}
          </span>
        )}
        {hint && !error && (
          <span id={`${inputId}-hint`} className="input-group__hint">
            {hint}
          </span>
        )}
        {maxLength && (
          <span className="input-group__counter">
            {value.length}/{maxLength}
          </span>
        )}
      </div>
    </div>
  );
}
